import React from 'react';
import { useSelector } from 'react-redux';
import { currencyFormat } from '../../Services/formatting';
import { translate } from '../../Services/translation';
import { getStackedItem } from '../../Services/ConfiguratorService';

const StackedPrices = () => {
  const stackedPrices = useSelector((state) => state.configurator.stackedPrices),
    totalWeight = useSelector((state) => state.configurator.totalWeight);

  if (!stackedPrices) {
    return <div className='configurator-box'>{translate('stacked.price.missingprices')}</div>
  }

  const { quantityPriceList, pricingUnitDisplayName, factorKg, pricingUnit } = stackedPrices;
  const stackedItem = getStackedItem(stackedPrices, totalWeight);

  const getStackedQuantity = (quantityPriceList, stackedItem) => {
    return stackedItem ? stackedItem.quantity : quantityPriceList[0].quantity;
  };

  const getMeterProgress = (quantityPriceList, stackedQuantity) => {
    let max = quantityPriceList.length,
      selectedIndex = 0;

    for (let i = 1; i < max; i++) {
      if (quantityPriceList[i].quantity === stackedQuantity) {
        selectedIndex = i + 1;
        break;
      }
    }

    if (selectedIndex === 0) {
      selectedIndex += 0.5;
    } else if (selectedIndex !== max) {
      selectedIndex -= 0.5;
    }

    return (selectedIndex > 0 ? (selectedIndex / max) * 100 : 0) + '%';
  };

  const renderDecimal = (value, useFactor) => {
    if (useFactor && pricingUnit !== 'kg') {
      return new Intl.NumberFormat(window.__litium.constants.currentLocale, {
        style: 'decimal',
        maximumFractionDigits: 0,
      }).format(value / factorKg);
    } else {
      return new Intl.NumberFormat(window.__litium.constants.currentLocale, {
        style: 'decimal',
        maximumFractionDigits: 2,
      }).format(value);
    }
  };

  const stackedQuantity = quantityPriceList && quantityPriceList.length ? getStackedQuantity(quantityPriceList, stackedItem) : null;

  return (
    <div className='configurator-box'>
      <div className='configurator-box__content'>
        {stackedQuantity ? (
          <div className='stacked-price-box'>
            <div className='stacked-price-box__unit'>{'KG'}</div>
            <ul className='stacked-price-box__data-list'>
              {quantityPriceList.map((value, index) => (
                <li key={index} className={value.quantity === stackedQuantity ? 'stacked-price-box__highlighted' : ''} >
                  <div className='stacked-price-box__kg'>
                    <a>{renderDecimal(value.quantity, false)}</a>
                  </div>
                  <div>
                    <a>{renderDecimal(value.price, false)}</a>
                  </div>
                </li>
              ))}
            </ul>
            <div className='stacked-price-box__meter'>
              <div
                className='stacked-price-box__progress'
                style={{ width: getMeterProgress(quantityPriceList, stackedQuantity), }}>

              </div>
            </div>
            <div className='stacked-price-box__unit'>
              {currencyFormat.formatToParts(0).find((e) => e.type === 'currency').value}
              {'/'}
              {pricingUnitDisplayName}
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

export default StackedPrices;
